import React, { useEffect, useState } from "react";
import { Collapse, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as DropdownSVG } from "go-component/images/svg/angle-input.svg";
import { useWindowSize } from "go-core/components/useWindowSize";
import { selectOrganization } from "../../../../../../../lib/go-security/services/organizations/selectors";

const SupportAccessNavigation = () => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();
	const size = useWindowSize();
	const [collapseOpen, setCollapseOpen] = useState(false);

	useEffect(() => {
		setCollapseOpen(false);
	}, [window.location.href]);

	const getRouteName = () => {
		return t("modules.service_access.help_center.title");
	};

	return (
		<div className="contextual-navigation">
			{!size.isMobile ? (
				<>
					<div className="navigation-header">
						<h2>{"modules.service_access.help_center.title"}</h2>
					</div>
					<div className="navigation-body">
						<Nav variant="pills" className="flex-column">
							<Nav.Item>
								<Nav.Link as={NavLink} to={`/${organization.id}/help/support_access`}>
									{t("modules.service_access.help_center.title")}
								</Nav.Link>
							</Nav.Item>
						</Nav>
					</div>
				</>
			) : (
				<>
					<div className="navigation-header">
						<h2 onClick={() => setCollapseOpen(!collapseOpen)}>
							{getRouteName()} <DropdownSVG />
						</h2>
					</div>
					<Collapse in={collapseOpen}>
						<div className="navigation-collapse">
							<Nav variant="pills" className="flex-column">
								<Nav.Item>
									<Nav.Item>
										<Nav.Link as={NavLink} to={`/${organization.id}/help/support_access`}>
											{t("modules.support_access.header.title")}
										</Nav.Link>
									</Nav.Item>
								</Nav.Item>
							</Nav>
						</div>
					</Collapse>
				</>
			)}
		</div>
	);
};
export default SupportAccessNavigation;
